import React, { useState, useEffect } from "react";
import "../Css/CustomerHistory.css";
import Header from "../Header";
import {
  ArrowLeft,
  CheckCircle2,
  AlertCircle,
  Clock,
  Car,
  ParkingMeter,
} from "lucide-react";
import { Link } from "react-router-dom";
import GreyArrow from "../../assets/greyLeftAr.png";
import { Button } from "@mui/material";
import {
  handleError,
  goBack,
  formatDateStringdot,
  handleSuccess,
  formatBookingId,
  mondayDayYearFormat,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  get_weekly_report_all_driver,
  generate_links_and_update_ledger,
} from "../../ServiceConnection/serviceconnection.js";
import Loader from "../Loader.js";

const DriverReport = () => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [driverData, setDriverData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const itemsPerPage = 10; // Number of items per page

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_weekly_report_all_driver, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log("API Response:", Response.data.message);
          setDriverData(Response.data.message.user_data || []); // Adjust based on API response structure
          setFilteredData(Response.data.message.user_data || []); // Initialize filtered data
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const refreshData = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(generate_links_and_update_ledger, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(
            Response.data.message || "Failed to refresh data. Please try again."
          );
        } else {
          handleSuccess("Data refreshed successfully!");
          master_data_get();
          // window.location.reload();
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    setCurrentPage(1); // Reset to first page on search
    const filtered = driverData.filter((row) =>
      Object.values(row).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchValue.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleStatusChange = (e) => {
    const status = e.target.value.toLowerCase();
    setStatusFilter(status);
    setCurrentPage(1); // Reset to first page on filter

    if (status === "") {
      setFilteredData(driverData);
    } else {
      console.log(status, "status");
      const filtered = driverData.filter((row) => {
        const step = row?.booking_data?.step_for_booking;
        const bookingStatus = step == 4 ? "active" : "inactive";
        return bookingStatus === status.toLowerCase();
      });
      setFilteredData(filtered);
    }
  };

  const getStatusBadge = (booking) => {
    let dayweek = "Day";
    if (booking.payment_day_week === 2) {
      dayweek = "Week";
    }
    ///payment_cycle_switch
    const { step_for_booking, fill_aggriment_status, payment_cycle_switch } =
      booking;
    console.log(
      step_for_booking,
      fill_aggriment_status,
      payment_cycle_switch,
      dayweek
    );
    switch (step_for_booking) {
      case "0":
        return (
          <div className="status-badge status-new">
            <Clock size={16} className="status-icon" />
            <span>New</span>
          </div>
        );
      case "1":
        return (
          <div className="status-badge status-inprogress">
            <Clock size={16} className="status-icon" />
            <span>InProgress</span>
          </div>
        );
      case "2":
        return fill_aggriment_status == "0" ? (
          <div className="status-badge status-not-signed">
            <AlertCircle size={16} className="status-icon" />
            <span>Agreement not signed</span>
          </div>
        ) : (
          <div className="status-badge status-signed">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Agreement signed</span>
          </div>
        );
      case "3":
        return (
          <div className="status-badge status-ready">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Ready for Pickup</span>
          </div>
        );
      case "4":
        return (
          <>
            <div className="status-badge status-ongoing mb-0">
              <Car size={16} className="status-icon" />
              <span>OnGoing</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        );
      case "5":
        return payment_cycle_switch == "1" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Payment Cycle Switch</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : payment_cycle_switch === "2" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Ipass Switch</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : payment_cycle_switch === "3" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Car Switch</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : payment_cycle_switch === "4" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Drop After Repo</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="status-badge status-completed mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Completed</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        );
      case "6":
        return (
          <div className="status-badge status-ongoing">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Car Switch Ongoing</span>
          </div>
        );
      case "7":
        return (
          <div className="status-badge status-rejected">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Repossessed</span>
          </div>
        );
      case "9":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Cancelled</span>
          </div>
        );
      case "10":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Rejected</span>
          </div>
        );
      case "11":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Canceled</span>
          </div>
        );
      default:
        return (
          <div className="status-badge">
            <Clock size={16} className="status-icon" />
            <span>Unknown</span>
          </div>
        );
    }
  };

  const getStatusClass = (status) => {
    //console.log("status", status);
    let final_status = status.toLowerCase();
    switch (final_status) {
      case "active":
        return "cust_hist_status_active";
      case "inactive":
        return "cust_hist_status_completed";
      default:
        return "";
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  function formatTimeTo24Hour(timeString) {
    if (!timeString) return "-";

    const [hourStr, minuteStr] = timeString.split(":");
    return `${hourStr}:${minuteStr}`;
  }

  const renderPaginationButtons = () => {
    const buttons = [];
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          <p className="breadcrumb-item">All Drivers Reports</p>
          <img src={GreyArrow} alt="Rapid Car Leasing" />
        </div>
        <div>
          <Button
            onClick={() => refreshData()}
            className="Back_bttn_page"
            style={{ marginRight: " 10px" }}
          >
            Refresh Data
          </Button>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>
      </div>
      <div className="cust_hist_container">
        <div className="cust_hist_card">
          <div className="cust_hist_card_header">
            <div className="cust_hist_header_container">
              <h3 className="cust_hist_title">All Drivers Report</h3>
              <div className="search-filter">
                <div className="cust_hist_search_container">
                  <svg
                    className="cust_hist_search_icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <input
                    type="text"
                    className="cust_hist_search_input"
                    placeholder="Search bookings..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
                <select
                  className="cust_hist_select"
                  value={statusFilter}
                  onChange={handleStatusChange}
                >
                  <option value="">All Statuses</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  {/* <option value="due">Due</option>
                  <option value="balance">Balance</option> */}
                </select>
              </div>
            </div>
          </div>

          <div className="reservationHistoryTable">
            <div
              className="historyTableContainer stickyTableheigh274"
              style={{ overflowX: "auto" }}
            >
              <table className="table margin_class_table">
                <thead className="stickyHeaderClss">
                  <tr>
                    <th scope="col">Booking ID</th>
                    <th scope="col">Driver Details</th>
                    <th scope="col">Status</th>
                    <th scope="col">Dates</th>
                    <th scope="col">Balance/Dues</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((option, index) => (
                      <tr className="historyTableRow" key={index}>
                        <td>
                          <div
                            style={{
                              marginLeft: "0.5rem",
                              fontSize: "14px",
                              marginTop: "1.2rem",
                              fontWeight: "500",
                              color: "var(--medium-text)",
                            }}
                          >
                            #{formatBookingId(option.booking_data.primary_id)}
                          </div>
                        </td>
                        <td>
                          <div className="topMargin historyTime">
                            <div className="historyTimeImgText align-items-start">
                              <p>
                                <span style={{ fontWeight: "700" }}>
                                  {option.name}
                                </span>
                                <p>{option.mobile_no}</p>
                                <p>{option.email}</p>
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="historyTableRowText historyStatus">
                            <button
                              type="button"
                              className={`markVip m-0`}
                              style={{
                                width: "fit-content",
                                backgroundColor: "transparent",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {getStatusBadge(option?.booking_data)}
                            </button>
                          </div>
                        </td>
                        <td>
                          <div
                            className="historyTableRowText historyPerson"
                            style={{ flexWrap: "wrap" }}
                          >
                            <div>
                              <p>
                                Payment Due Date:{" "}
                                {option?.booking_data?.last_link_date ==
                                null ? (
                                  "Not Generated"
                                ) : (
                                  <p>
                                    {formatDateStringdot(
                                      option.booking_data.last_link_date
                                    )}
                                  </p>
                                )}
                              </p>
                            </div>
                            <div>
                              <p>
                                PickUp Date:{" "}
                                {option.booking_data.step_for_booking < "4" ? (
                                  "-"
                                ) : (
                                  <>
                                    {mondayDayYearFormat(
                                      option.booking_data.from_date
                                    )}
                                  </>
                                )}
                              </p>
                            </div>
                            <div>
                              <p>
                                PickUp Time:{" "}
                                {formatTimeTo24Hour(
                                  option.booking_data.new_from_time
                                )}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            className="historyTableRowText historyPerson"
                            style={{ flexWrap: "wrap" }}
                          >
                            <p>
                              <strong style={{ color: "green" }}>
                                Total Paid:
                              </strong>{" "}
                              ${option.booking_data?.total_paid?.toFixed(2) || "0.00"}
                            </p>
                            <p>
                              <strong style={{ color: "red" }}>
                                {option.booking_data.step_for_booking == "5"
                                  ? "Previous Due"
                                  : "Due"}
                              </strong>{" "}
                              ${option.booking_data?.total_due?.toFixed(2) || "0.00"}
                            </p>
                            <p>
                              <strong style={{ color: "orange" }}>
                                Advance:
                              </strong>{" "}
                              ${option.booking_data?.balance_advance?.toFixed(2) || "0.00"}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div className="historyActionsBtns flex-row justify-content-start mb-2">
                            <div className="Action_booking_btn">
                              <Link
                                to="/WeeklyReport"
                                state={{ option: option?.booking_data }}
                              >
                                <button
                                  className="instructions Add_Instructions"
                                  title="View Current Report"
                                  style={{
                                    cursor: "pointer",
                                    paddingRight: "10px",
                                  }}
                                >
                                  Current Report
                                </button>
                              </Link>
                            </div>
                            <div className="Action_booking_btn">
                              <Link
                                to={`/driver-all-reports/${option.primary_id}`}
                              >
                                <button className="instructions Add_Instructions">
                                  View All Reports
                                </button>
                              </Link>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text_align_center">
                        No Results Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="cust_hist_card_footer">
            <div className="cust_hist_pagination_info">
              Showing{" "}
              <span className="cust_hist_pagination_bold">
                {indexOfFirstItem + 1}
              </span>{" "}
              to{" "}
              <span className="cust_hist_pagination_bold">
                {Math.min(indexOfLastItem, filteredData.length)}
              </span>{" "}
              of{" "}
              <span className="cust_hist_pagination_bold">
                {filteredData.length}
              </span>{" "}
              drivers
            </div>
            <div className="cust_hist_pagination">
              <nav aria-label="Pagination">
                <ul className="cust_hist_pagination_list">
                  {renderPaginationButtons()}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DriverReport;
